module.exports = __webpack_public_path__ + "169551d1e3d8a217381117d26e6e15ce.svg";